import * as React from "react";
import { CreditCard } from "lucide-react";
import { UniversalSelector } from "@/components/ui/universal-selector";

interface Account {
  id: string;
  name: string;
  color?: string;
  initialBalance?: number;
}

interface AccountSelectorProps {
  accounts: Account[];
  value: string;
  onValueChange: (value: string) => void;
  placeholder?: string;
  allowFreeText?: boolean;
  freeTextValue?: string;
  onFreeTextChange?: (value: string) => void;
  label?: string;
  error?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  onEnterPress?: () => void;
  required?: boolean;
  canAddNew?: boolean;
  onAddNew?: (name: string) => Promise<void>;
}

export function AccountSelector({
  accounts,
  value,
  onValueChange,
  placeholder = "Selecione uma conta",
  allowFreeText = false,
  freeTextValue = "",
  onFreeTextChange,
  label = "Conta Financeira",
  error,
  inputRef,
  onEnterPress,
  required = true,
  canAddNew = false,
  onAddNew
}: AccountSelectorProps) {
  
  const displayFunction = (account: Account): React.ReactNode => {
    return (
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <div 
          className="w-3 h-3 rounded-full flex-shrink-0" 
          style={{ backgroundColor: account.color || '#64748B' }}
        />
        <span className="font-medium truncate">{account.name}</span>
      </div>
    );
  };

  return (
    <UniversalSelector
      items={accounts}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      allowFreeText={allowFreeText}
      freeTextValue={freeTextValue}
      onFreeTextChange={onFreeTextChange}
      label={label}
      error={error}
      inputRef={inputRef}
      onEnterPress={onEnterPress}
      icon={CreditCard}
      displayFunction={displayFunction}
      required={required}
      canAddNew={canAddNew}
      onAddNew={onAddNew}
      addNewLabel="Adicionar Nova Conta"
    />
  );
}